import {
  LINE_CTA_LABEL,
  LINE_OFFICIAL_URL,
} from '@/pages/gmb-audit/consult/config';

type LineVariant = 'primary' | 'outline' | 'inverse';
type LineSize = 'md' | 'lg';

/**
 * 天地人網 LINE 官方帳號 CTA（共用元件，V1 Conversion-1.1 正式啟用）。
 * - 一律以新分頁開啟正式 LINE 官方帳號（rel="noopener noreferrer"）。
 * - 不在 URL 帶任何 token / report JSON；只是外部聯絡 CTA。
 * - variant:
 *   primary  = 實心深綠（用於淺色底的主要 LINE 動作）
 *   outline  = 淺色底 outline（白底 / 淡綠底情境）
 *   inverse  = 深色底 inverse outline（深綠 CTA 區塊，白字白框，hover 反白）
 */
export default function LineCtaButton({
  variant = 'outline',
  size = 'lg',
  fullWidth = false,
  className = '',
}: {
  variant?: LineVariant;
  size?: LineSize;
  fullWidth?: boolean;
  className?: string;
}) {
  const sizeClass = size === 'lg' ? 'h-14 px-6 text-base' : 'h-12 px-5 text-base';

  const widthClass = fullWidth ? 'w-full' : 'w-full sm:w-auto';

  const base = `inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-xl font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 ${sizeClass} ${widthClass} ${className}`;

  const variantStyle: Record<LineVariant, string> = {
    primary:
      'bg-primary-700 text-background-50 hover:bg-primary-800 focus-visible:ring-primary-400 focus-visible:ring-offset-background-50',
    outline:
      'border border-background-400 bg-background-50 text-foreground-700 hover:bg-background-100 focus-visible:ring-primary-400 focus-visible:ring-offset-background-50',
    inverse:
      'border border-background-50/75 bg-transparent text-background-50 hover:border-background-50 hover:bg-background-50 hover:text-primary-800 focus-visible:ring-background-50/80 focus-visible:ring-offset-primary-700',
  };

  return (
    <a
      href={LINE_OFFICIAL_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={`${base} ${variantStyle[variant]}`}
    >
      <i className="ri-line-fill text-lg" />
      {LINE_CTA_LABEL}
    </a>
  );
}